<template>
  <div class="thanks-wrapper">
    <Header />
    <section class="thanks">
      <CheckCircle />
      <div class="description">
        <h1 class="title">Спасибо!</h1>
        <p class="text">Наш менеджер скоро с Вами свяжется.</p>
      </div>
      <div class="track" />
    </section>
    <section class="introduce">
      <div class="description">
        <h2 class="title">Познакомимся поближе?</h2>
        <p class="text">
          Заполните форму, чтобы получить персональные рекомендации  по работе с сервисом.
        </p>
      </div>
      <SurveyForm class="form" />
      <p class="text">или</p>
      <Button class="back-home" @click="backHome">Вернуться на главную</Button>
      <ThnaksGradient class="gradient" />
    </section>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/homePage/Header.vue";
import Footer from "@/components/homePage/Footer.vue";
import CheckCircle from "@/assets/icons/check-circle.svg";
import Button from "@/components/homePage/Button.vue";
import SurveyForm from "@/components/thanksPage/SurveyForm.vue";
import { homePath } from "@/router/home";
import ThnaksGradient from "@/assets/icons/thanks-gradient.svg";

export default {
  name: "Thanks",
  components: {
    Header,
    Footer,
    CheckCircle,
    Button,
    SurveyForm,
    ThnaksGradient,
  },
  data() {
    return { homePath };
  },
  methods: {
    backHome() {
      this.$router.push(homePath);
    },
  },
};
</script>

<style scoped lang="less">
.thanks-wrapper {
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  background-color: #ffffff;
  > section {
    margin-top: 160px;
    @media (max-width: 1439px) {
      margin-top: 80px;
    }
    @media (max-width: 767px) {
      margin-top: 32px;
    }
    .title {
      font-family: Montserrat;
      font-weight: 600;
      font-size: 64px;
      line-height: 1;
      margin: 0;
      @media (max-width: 1439px) {
        font-family: Montserrat;
        font-weight: 600;
        font-size: 48px;
        line-height: 1;
      }
      @media (max-width: 767px) {
        font-family: Montserrat;
        font-weight: 600;
        font-size: 32px;
        text-align: center;
      }
    }
  }
  .thanks {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 52px;
    @media (max-width: 1439px) {
      gap: 24px;
    }
    @media (max-width: 1439px) {
      gap: 24px;
    }

    .description {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 25px;
      max-width: 507px;
      padding: 0 42px;
      @media (max-width: 1439px) {
        max-width: 338px;
        padding: 0;
      }
      @media (max-width: 767px) {
        max-width: 309px;
      }
      .text {
        font-family: Montserrat;
        font-weight: 400;
        font-size: 24px;
        line-height: 1.2;
        text-align: center;
        @media (max-width: 1439px) {
          font-family: Montserrat;
          font-weight: 400;
          font-size: 20px;
          line-height: 1;
        }
        @media (max-width: 767px) {
          font-family: Montserrat;
          font-weight: 500;
          font-size: 18px;
        }
      }
    }
    .track {
      max-width: 795px;
      width: 100%;
      height: 9px;
      border-radius: 11px;
      background-color: #d9d9d9;
      position: relative;
      @media (max-width: 1439px) {
        max-width: 550px;
      }
      @media (max-width: 767px) {
        max-width: 303px;
      }
      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 50%;
        background: linear-gradient(90deg, #18e4f2 0%, #857fcf 100%);
        border-radius: 11px;
      }
    }
  }
  .introduce {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 52px;
    background-color: #484e55;
    padding: 80px 0;
    color: white;
    position: relative;
    @media (max-width: 1439px) {
      gap: 24px;
    }
    @media (max-width: 767px) {
      padding: 32px 10px;
    }
    .text {
      font-family: Montserrat;
      font-weight: 500;
      font-style: Medium;
      font-size: 24px;
      line-height: 1.2;
      text-align: center;
      max-width: 840px;
      @media (max-width: 1439px) {
        font-family: Montserrat;
        font-weight: 500;
        font-size: 20px;
        line-height: 1;
        max-width: 550px;
      }
      @media (max-width: 767px) {
        font-family: Montserrat;
        font-weight: 500;
        font-size: 18px;
        max-width: 340px;
      }
    }
    .description {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 25px;
    }
    .back-home {
      max-width: 480px;
      width: 100%;
      height: 60px;
      font-family: Montserrat;
      font-weight: 600;
      font-size: 20px;
      line-height: 1;
    }
    .description,
    .form,
    .text,
    .back-home {
      position: relative;
      z-index: 1;
    }
    .gradient {
      position: absolute;
      z-index: 0;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      @media (max-width: 737px) {
        width: 1146;
        height: 798;
      }
    }
  }
}
</style>
